/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=53d9df70"
const script = {}

import "./App.vue?vue&type=style&index=0&id=53d9df70&lang=sass"

import exportComponent from "/var/jenkins_home/workspace/生产环境微信商家助手yinboshi_weixin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__